import React, { useState } from 'react';
import {
    TextField,
    Button,
    Typography,
    Link,
    Alert,
    Box,
    styled,
} from '@mui/material';
import axios from 'axios';
import BGImg from '../assets/BG-Join-Clients.png';
import airTeachrLogo from '../assets/airTeachr-Logo.png';
const BookingButton = styled(Button)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px',
    width: '100%',
    maxWidth: '200px',
    borderRadius: '30px',
    marginTop: '1.5rem',
    marginBottom: '1.5rem',
    textTransform: 'capitalize',
    letterSpacing: '1.2px',
    background: '#4632DA',
    '&:hover': {
        backgroundColor: '#06D9FA',
        color: '#ffffff',
    },
}));
const IconLink = styled(Link)({
    marginRight: '10px',

    color: '#06D9FA',
    '&:hover': {
        color: '#4632da',
    },
});

const FollowUs = () => {
    return (
        <Box display="flex" flexDirection="column" alignItems="center">
            <Box display="flex" justifyContent="center" marginY=".8rem">
                <IconLink href="https://www.facebook.com/profile.php?id=100086238769033">
                    <svg
                        aria-hidden="true"
                        className="e-font-icon-svg e-fab-facebook-square"
                        viewBox="0 0 448 512"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ width: '24px', height: '24px' }}
                    >
                        <path
                            fill="currentColor"
                            d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
                        ></path>
                    </svg>
                </IconLink>
                <IconLink href="https://www.instagram.com/airteachr.aus/">
                    <svg
                        aria-hidden="true"
                        className="e-font-icon-svg e-fab-instagram"
                        viewBox="0 0 448 512"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ width: '24px', height: '24px' }}
                    >
                        <path
                            fill="currentColor"
                            d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                        ></path>
                    </svg>
                </IconLink>
                <IconLink href="https://www.linkedin.com/company/airteachr">
                    <svg
                        aria-hidden="true"
                        className="e-font-icon-svg e-fab-linkedin"
                        viewBox="0 0 448 512"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ width: '24px', height: '24px' }}
                    >
                        <path
                            fill="currentColor"
                            d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                        ></path>
                    </svg>
                </IconLink>
            </Box>
            <Typography variant="body2">© 2024 All Rights Reserved</Typography>
        </Box>
    );
};
function UnsubscribePage() {
    const [postcode, setPostcode] = useState('');
    const [email, setEmail] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    // const handleCloseSnackbar = (event, reason) => {
    //     if (reason === 'clickaway') {
    //         return;
    //     }
    //     setOpenSnackbar(false);
    // };

    const handleUnsubscribe = async () => {
        // Check if the email field is empty or if it's not a valid email address
        if (!email || !validateEmail(email)) {
            setSnackbarMessage('Please enter a valid email address.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
            return;
        }

        try {
            const response = await axios.get('/unsubscribe', {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                timeout: 30000,
                params: {
                    postcode: postcode,
                    email: email,
                },
            });
            if (response.data.schools.Message.Success) {
                setSnackbarMessage('Email Unsubscribed Successfully');
                setSnackbarSeverity('success');
                setButtonDisabled(true);
                setOpenSnackbar(true);
            } else {
                setSnackbarMessage('Email not found');
                setSnackbarSeverity('error');
                setOpenSnackbar(true);
            }
            setOpenSnackbar(true);
        } catch (error) {
            console.error('Error unsubscribing email:', error);
            setSnackbarMessage('Error Unsubscribing Email');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
        }
    };

    // Function to validate email format
    const validateEmail = email => {
        const re =
            // eslint-disable-next-line no-useless-escape
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    return (
        <div
            style={{
                position: 'absolute',
                zIndex: '1000',
                height: '100%',
                minHeight: '100vh',
                width: '100%',
                top: '0px',
                left: '0',
                backgroundImage:
                    'linear-gradient(130deg, #4632da 0%, #06d9fa 89%)',
                backgroundColor: 'rgba(0, 0, 0, 0)',
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    content: '',
                    opacity: 0.15,
                    height: '100%',
                    width: '100%',
                    top: 0,
                    left: 0,
                    backgroundImage: `url(${BGImg})`,
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    zIndex: -100,
                }}
            ></div>

            <Box
                sx={{
                    background: '#fff',
                    margin: 'auto',
                    padding: 3,
                    position: 'relative',
                    top: '50%',
                    left: 0,
                    transform: 'translateY(-50%)',
                    maxWidth: 550,
                }}
            >
                <Box
                    sx={{
                        maxWidth: '300px',
                        margin: 'auto',
                        marginBottom: '20px',
                    }}
                >
                    <img
                        style={{ width: '100%' }}
                        src={airTeachrLogo}
                        alt="airTeachr Logo"
                    />
                </Box>
                <Typography
                    variant="body1"
                    gutterBottom
                    textAlign="center"
                    marginBottom="4rem"
                    marginX="auto"
                >
                    We are sorry to see you go!
                </Typography>
                <Box
                    sx={{
                        position: 'relative',
                        maxWidth: 350,
                        margin: 'auto',
                        textAlign: 'center',
                    }}
                >
                    <TextField
                        label="Postcode (Suburb of the school)"
                        placeholder="Enter the suburb of the school"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={postcode}
                        onChange={e => {
                            setPostcode(e.target.value);
                            setOpenSnackbar(false);
                            setButtonDisabled(false);
                        }}
                    />
                    <TextField
                        label="Email Address"
                        variant="outlined"
                        placeholder="Enter your email address"
                        fullWidth
                        margin="normal"
                        value={email}
                        onChange={e => {
                            setEmail(e.target.value);
                            setOpenSnackbar(false);
                            setButtonDisabled(false);
                        }}
                    />
                    <Box height="54px">
                        {openSnackbar && (
                            <Alert
                                variant="filled"
                                severity={snackbarSeverity}
                                sx={{ color: '#fff' }}
                            >
                                {snackbarMessage}
                            </Alert>
                        )}
                    </Box>
                    <BookingButton
                        variant="contained"
                        onClick={handleUnsubscribe}
                        disabled={
                            buttonDisabled || email === '' || postcode === ''
                        }
                    >
                        Unsubscribe
                    </BookingButton>
                </Box>
                <FollowUs />
            </Box>
        </div>
    );
}

export default UnsubscribePage;
